










export default {
    props: {
        name: {
            required: true,
            type: String,
        },
    },

    filters: {
        fullnameToInitials: function (name: string) {
            return name
                .split(" ")
                .map((n) => n[0])
                .join("");
        },
    },
};
